import React ,{Component} from 'react';
import {connect} from 'react-redux';

import Popover from '@material-ui/core/Popover';
import { Button, Grid } from '@material-ui/core';
import moment from 'moment';


//Font Awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClock,
    faMapMarkerAlt,
    faBars,
    faUserFriends,
} from "@fortawesome/free-solid-svg-icons"


export class ActivityDetailsModal extends Component{
    constructor(props){
        super();
        this.state={
            //anchorEl
            anchorEl:undefined,
            //popOver
            popOverDirection: 'right',
            //localDates
            startDate:undefined,
            endDate:undefined,
        }
    };


    //#region Methods
    componentDidMount = ()=>{
        window.addEventListener('resize', this.resize);


        if(this.props){

            if(this.props.idAnchorEl){
                this.setAnchorEl(this.props.idAnchorEl)
            }
            
            const startDate = (this.props.activityObj && this.props.activityObj.date) ?  this.props.activityObj.date : undefined;
            const endDate = (this.props.activityObj && this.props.activityObj.endDate) ?  this.props.activityObj.endDate : undefined;
            const timeZoneName = this.props.timeZoneName? this.props.timeZoneName : undefined;

            if(startDate && endDate && timeZoneName){
                const localStartDate = this.getLocalDate(startDate, timeZoneName);
                const localEndDate = this.getLocalDate(endDate, timeZoneName);

                this.setState({
                    startDate: localStartDate,
                    endDate: localEndDate,
                })
            }
        }
    }

    componentWillUnmount= () =>{
        window.removeEventListener('resize', this.resize);
    }

    resize = ()=> {
        if(this.props && this.props.idAnchorEl){
            //this.props.onCloseActivityDetails();
            this.setAnchorEl(this.props.idAnchorEl)
        }           
    };


    setAnchorEl(idAnchorEl){
        const anchorEl = document.getElementById(idAnchorEl);

        let direction = 'right';

        if(anchorEl){

            direction = this.getPopOverDirection(this.props.activityObj.date);
            this.setState({
                anchorEl: anchorEl,
                popOverDirection: direction,
            })
        }
    };

    getPopOverDirection = (date) => {
        const newMoment = moment(date);
        let direction = 'left';

        try{
            switch(newMoment.day()){
                case 5:
                case 6:
                        direction='right';
                    break;
                default:
                        direction = 'left';
                    break;

            }
        }catch(err){}

        return direction;
    };


    getLocalDate = (date, timeZoneName) => {
        try{
            const localDate= new Date(new Date(date).toLocaleString("en-US",{timeZone: timeZoneName}));
            
            return localDate;

        } catch(err){
            
        }
    };


    GetCategoryInitials(categoryName){
        // (categoryName!=undefined)? categoryName: categoryName = 'Special event';
        let categoryWords = categoryName.split(' ');

        categoryWords = categoryWords.filter(item => item !== '&' );

        const CategoryBadge= categoryWords.map(word =>word.charAt(0).toUpperCase()).join('').slice(0,2);
        return CategoryBadge;
    };

    getTimeString = (startDate, endDate) =>{

        let stringDate =moment(startDate).format("dddd, MMMM D, yyyy");
        let startTime = moment(startDate).format("hh:mm A");
        let endTime = moment(endDate).format("hh:mm A");

        stringDate = stringDate+' ' +startTime+ ' - '+ endTime

        return stringDate;

    }


    getDiffInMin = (startDate, endDate) =>{
        try{
            let diff = (endDate - startDate)/ 60000;

            return diff;
        }catch(err){}
    }
    //#endregion

    //#region  Inner Componnets
    activityComponent = () =>{


 
        return(
            <Grid container >
                <Grid item container  className='popOverInfoContainer'>
                    <this.activityTitleComponent
                        activityTitle ={this.props.activityObj.title}
                        activityCategory ={this.props.activityObj.category}
                    />
                </Grid>
                <Grid item container  className='popOverInfoContainer'>
                    <this.activityTimeComponent
                        startTime={this.state.startDate}
                        endTime={this.state.endDate}
                    />
                </Grid>
                <Grid item container  className='popOverInfoContainer'>
                    <this.activityLocationComponent
                        activityLocation = {this.props.activityObj.location? this.props.activityObj.location : undefined }
                    />
                </Grid>
                <Grid item container  className='popOverInfoContainer'>
                    <this.activityDescriptionComponent
                        activityDescription= {this.props.activityObj.description? this.props.activityObj.description : undefined }
                    />
                </Grid>
                <Grid item container  className='popOverInfoContainer'>
                    <this.activityRegistreesComponents
                        numberAtendees={this.props.activityObj.attendees? this.props.activityObj.attendees.filter(item => item.subscribed === true).length : 0 }
                    />
                </Grid>
                <Grid item container className='popOverButtonContainer'>
                    <this.activityActionButtonsContainer
                        activityObj={this.props.activityObj? this.props.activityObj : undefined}
                    />
                </Grid>
            </Grid>
        )
    };


    activityTitleComponent = ({activityTitle, activityCategory}) =>{


        const width= 30;
        const styles = {
            activityTitle:{
                alignContent:'middle',
                alignItems:'middle',
                color:'#ecebeb',
                fontSize:'20px',
            },
            categoryBadge:{

                backgroundColor:activityCategory.categoryColor,
                borderRadius:'50%',
                color:'#ecebeb',
                height:width+'px',
                width:width+'px',
            },
        }

        return(
            <Grid item container >
                <Grid item container xs={2}  justify='center' alignItems='center'>
                    <Grid item container justify='center' alignItems='center' style={{...styles.categoryBadge}}>
                        <Grid item >
                            {this.GetCategoryInitials(activityCategory.name)}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={10}  className='popOverTitle popOverHideOnOverFlow' justify='center' alignItems='center' >
                    {activityTitle}
                </Grid>
            </Grid>
        )
    };


    activityTimeComponent = ({startTime, endTime}) =>{
        return(
            <Grid item container>
                <Grid item container  xs={2} justify='center' alignItems='center'>
                    <Grid item container className='popOverIcon' justify='center' alignItems='center'>
                        <FontAwesomeIcon
                            className="icon-menu-size"
                            icon={faClock}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={10} className='popOverInfo' justify='center' alignItems='center' >
                    {this.getTimeString(startTime,endTime)}
                    <span className='popOverMin'>
                        {'('+this.getDiffInMin(startTime, endTime)+' Min)'}
                    </span>
                </Grid>
            </Grid>
        )

    };

    activityLocationComponent = ({activityLocation}) => {
        return(
            <Grid item container>
                <Grid item  container  xs={2} justify='center' alignItems='center'>
                    <Grid item container className='popOverIcon' justify='center' alignItems='center' >
                        <FontAwesomeIcon
                            className="icon-menu-size"
                            icon={faMapMarkerAlt}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={10}   className='popOverInfo popOverHideOnOverFlow' justify='center' alignItems='center'>
                    {activityLocation}
                </Grid>
              
            </Grid>
        )
    };

    activityDescriptionComponent = ({activityDescription}) =>{
        return(
            <Grid item container>
                <Grid item  container  xs={2} justify='center' alignItems='center'>
                    <Grid item container className='popOverIcon' justify='center' alignItems='center'>
                        <FontAwesomeIcon
                            className="icon-menu-size"
                            icon={faBars}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={10}  className='popOverInfo' justify='center' alignItems='center'>
                    {(activityDescription && activityDescription.length >= 46)? activityDescription.slice(0,44) + ' ...': activityDescription }
                </Grid>              
            </Grid>
        )
    };

    activityRegistreesComponents = ({numberAtendees}) =>{
        const atendees = numberAtendees? numberAtendees : 0;

        return(
            <Grid item container>
                <Grid item  container  xs={2} justify='center' alignItems='center'>
                    <Grid item container  className='popOverIcon' justify='center' alignItems='center'>
                        <FontAwesomeIcon
                            className="icon-menu-size"
                            icon={faUserFriends}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={10}  className='popOverInfo popOverHideOnOverFlow' justify='center' alignItems='center'>
                    {atendees + ' registered'}
                </Grid>              
            </Grid>
        )
    };

    activityActionButtonsContainer = ({activityObj}) =>{
        return(
            <Grid item container justify='center' alignItems='center'>
                <Grid item >
                    <Button id='go_to_activity_btn' className='popOverActionButton' onClick={() => this.props.OnGoToActivity(activityObj)}>
                        Go to Activity
                    </Button>
                </Grid>
            </Grid>
        )
    };
    //#endregion

    //#region HANDELERS
    

    //#endregion

    render(){
        const  popOverDirection = this.state.popOverDirection? this.state.popOverDirection : 'left';
        const activityDirection = (popOverDirection && popOverDirection === 'left')? 'right': 'left';
        const markerClass = popOverDirection === 'right'?  'PopOverMarkerRight' : 'PopOverMarkerLeft';
        const anchorOrigin ={
            vertical: 'center',
            horizontal: activityDirection,
        };
        const transformOrigin = {
            vertical: 'center',
            horizontal:  popOverDirection,
        };
        const paperPropsPopOver = {
            className:  ( popOverDirection === 'right')? 'PopOver PopOverRight': 'PopOver PopOverLeft'
            
        }

        setTimeout(() => {
        const initialMarker = document.getElementsByClassName('initialMarker')[0];
        if(initialMarker){
            
            initialMarker.classList.remove('PopOverMarkerLeft');
            initialMarker.classList.remove('PopOverMarkerRight');
            initialMarker.classList.add(markerClass);
            }
        }, 150);

        let showMark = true;
        if(this.state.anchorEl){

            const rect = this.state.anchorEl.getBoundingClientRect();
            if(rect && rect.bottom){
                showMark = (window.innerHeight -rect.bottom) > 40? true: false;
            }
        
        }
        return(

            <>
            {
                this.state.anchorEl?
                <>
                {
                    showMark?
                  <Popover
                        id={'activitidetailsMarker'+this.props.activityObj._id}
                        open={true}
                        anchorEl={this.state.anchorEl}
                        onClose={this.props.onCloseActivityDetails}
                        anchorOrigin={anchorOrigin}
                        transformOrigin={transformOrigin}
                        PaperProps={{
                            className:'initialMarker',   
                        }}
                        elevation={0}
                
                    >
                    </Popover>
                    :
                    undefined
                }
                    <Popover
                        id={'activitidetails'+this.props.activityObj._id}
                        open={true}
                        anchorEl={this.state.anchorEl}
                        onClose={this.props.onCloseActivityDetails}
                        anchorOrigin={anchorOrigin}
                        transformOrigin={transformOrigin}
                        PaperProps={paperPropsPopOver}
                        elevation={0}
                
                    >
                        <Grid container  className='popOverChild' data-content={{border:'1px solid blue'}} justify='center' alignItems='center' style={{padding:'25px', position:'relative'}}>
                            <this.activityComponent/>
                        </Grid>
                    </Popover>
                
                   
                    
                </>
                :
                undefined
            }
            </>
                    )
    }
}


function mapStateToProps(state){  
    return{    };
};

export default connect(mapStateToProps, {})(ActivityDetailsModal)